var _rect, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1D6CEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.625 13C25.8856 13 29.9443 19.7153 30.1143 20.0012C30.2952 20.3062 30.2952 20.6938 30.1143 20.9988C29.9443 21.2847 25.8856 28 19.625 28C13.3644 28 9.30569 21.2847 9.13569 20.9988C8.95477 20.6938 8.95477 20.3062 9.13569 20.0012C9.30569 19.7153 13.3644 13 19.625 13ZM10.964 20.5C11.9778 21.9606 15.2538 26.125 19.625 26.125C24.0104 26.125 27.2757 21.9634 28.286 20.5C26.9296 18.5118 25.1531 16.8867 23.0984 15.7544C23.7119 16.5706 24.0478 17.5819 24.052 18.625C24.052 21.2138 22.07 23.3125 19.625 23.3125C17.18 23.3125 15.198 21.2138 15.198 18.625C15.2021 17.5789 15.54 16.565 16.1569 15.7478C14.0975 16.8781 12.3186 18.5062 10.964 20.5Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.2453e643efd6cf1143756ce48dd1fbcb.svg";
export { ForwardRef as ReactComponent };